import React, { useState, useContext } from "react";
import ReactDOM from 'react-dom';
import DiagramItem from "../DiagramItem/DiagramItem";
import "./Tools.css";
import CollapseCommand from "../Commands/CollapseCommand/CollapseCommand";
import HorizontalLine from "../Commands/HorizontalLine/HorizontalLine";
import EditIcon from "../Commands/EditIcon/EditIcon";
import SimpleModal from "../SimpleModal/SimpleModal";
import useModal from "../../Hooks/useModal";
import ToolTip from "../ToolTip/ToolTip";
import useGetCurrentsTools from "../../Hooks/useGetCurrentsTools.js";
import useUpdateOccurenceValue from "../../Hooks/useUpdateOccurenceValue.js";
import useChangeMode from "../../Hooks/useChangeMode.js";
import DropDownListNew from "../DropDownList/DropDownListNew";
import CheckBox from "../Commands/CheckBox/CheckBox";
import useValidationInput from "../../Hooks/useValidationInput.js";



import { store } from "../../store.js";

export default function Tools(props) {
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const getCurrentsTools = useGetCurrentsTools();
  const updateValue = useUpdateOccurenceValue();
  const [isShowToolTip, setIsShowToolTip] = useState(false);
  const [reduceds, setReduceds] = useState([]);
  const [currentSetting, setCurrentSetting] = useState({currentEvent:globalState.state.formData.actions.event.type.onLoad});
  const isInputValid = useValidationInput();
  const [tool, setTool] = useState({
    isToolOpen: true,
    currentId: 1,
  });
  const { isShowing, toggle } = useModal();
  const changeMode = useChangeMode();
  const getAllColumns = (container, columns=[]) => {
    if (!container.metaData) return columns;
    columns = [...columns, ...container.metaData.map((col) => {
      return getAllColumns(col, [{ id: col.id, item: col.properties.name.value }])
    })];
    return columns.flat(Infinity);
  };
  
  const allColumns = getAllColumns(globalState.state.formData)

  const property = { id: 1, name: "Properties" };
  const style = { id: 2, name: "Styles" };
  const tools = { id: 1, name: "Tools" };
  const settings = { id: 2, name: "Settings" };
  const menuItems = [{ id: 1, name: "Tools" }, { id: 2, name: "Settings" }]
  const firstCurrentTool = globalState.state.formData.currentTool[0];
  const currentToolIds = globalState.state.formData.currentTool.map(item => item.id);
  const currentToolGlobalIds = globalState.state.formData.currentTool.map(item => item.globalId);
  const onDragStart = (e, template) => {
    e.dataTransfer.setData("controlId", JSON.stringify(template));
  };

  const onExpandCollapseClick = (menuId) => {
    if (reduceds.includes(menuId)) {
      deleteMenuIdFromExpandeds(menuId);
    } else {
      addMenuIdToExpandeds(menuId);
    }
  };
 
  const onMouseMenu = (id) => {
    if (
      tool.currentId !== id && !currentToolIds.includes(0)
    ) {
      setTool({
        isToolOpen: !tool.isToolOpen,
        currentId: id,
      });
    }
  };

  const addMenuIdToExpandeds = (id) => {
    setReduceds([...reduceds, id]);
  };

  const deleteMenuIdFromExpandeds = (menuId) => {
    var newReduceds = reduceds.filter((item) => menuId != item);
    setReduceds(newReduceds);
  };
  
  const showMenu = (menu) => {
    if (menu == "") return;
    
    return (
      <li key={"li" + menu.id} name={menu.id}>
        <div
          id={menu.id}
          className="menuItem"
          draggable={true}
          onDragStart={(e) => onDragStart(e, menu.template)}
        >
          {menu.name}
        </div>
      </li>
    );
  };

  const changeValue = (newValue, menuItem, type, isProperty, options = undefined, changeMode = undefined) => {
    
    updateValue(newValue, menuItem, type, isProperty, currentSetting.currentEvent, {actualToolGlobalIds:currentToolGlobalIds, actualToolIds:currentToolIds}, options, undefined, 
       { maskData : "", groupSeparator : "",changeMode : changeMode});
    if (isShowing) toggle()
  };

  /*const getCondition = (menu, type) => {       
    var currentCondition = firstCurrentTool.conditions && firstCurrentTool.conditions
    .filter (condition => condition.type == type.toLowerCase() && condition.menu == menu)[0]
    if (currentCondition){ 
      return currentCondition.values 
    }
    else 
      return {value:"", isClick:false}
  }

  const getApi = (menu, type) => {
    var currentApi = firstCurrentTool.api && firstCurrentTool.api
    .filter (current => current.type == type.toLowerCase() && current.menu == menu)[0]
    
    if (currentApi){  
      
      return currentApi.values 
    }
    else 
      return {method: "GET", option:globalState.state.formData.actions.api.params , Params : {details:[]}}
  }*/

  const getCondition = (menu, type) => {       
    var currentCondition = firstCurrentTool[type.toLowerCase()][menu].conditions
    
    if (currentCondition){ 
      return currentCondition.values 
    }
    else 
      return {value:"", isClick:false}
  }

  const getApi = (menu, type) => {
    var currentApi = firstCurrentTool[type.toLowerCase()][menu].api
    if (currentApi){  
      return currentApi.values 
    }
    else 
      return {method: "GET", option:globalState.state.formData.actions.api.params , Params : {details:[]}}
  }

  const getOption = (menu, type, controlDataOptions) => {
    let option = firstCurrentTool[type.toLowerCase()][menu].option 
    
    //firstCurrentTool.option && firstCurrentTool.option[type] && firstCurrentTool.option[type][menu] && firstCurrentTool.option[type][menu].value
    if (option)
      return option
    else {
      let currentItem = globalState.state.formData.lists.validations[type.toLowerCase()][menu]
      return controlDataOptions ? controlDataOptions[0] :
        currentItem ? currentItem.options[0] : globalState.state.formData.actions.option.text
    }
  } 
/*
  const getOption = (menu, type, controlDataOptions) => {
    let option = firstCurrentTool.option && firstCurrentTool.option.filter(item => item.type == type.toLowerCase() && item.menu == menu)[0]
    
    
    //firstCurrentTool.option && firstCurrentTool.option[type] && firstCurrentTool.option[type][menu] && firstCurrentTool.option[type][menu].value
   
    let currentItem = globalState.state.formData.lists.validations[type.toLowerCase()][menu]
    return option ? option.value : 
    controlDataOptions ? controlDataOptions[0] :
    currentItem ? currentItem.options[0] : globalState.state.formData.actions.option.text
  } */
  
  const onToggle = () => {
    toggle()
    
    if (!globalState.state.formData.isEditTool) changeMode(true)
  }

  

  const showSettings = (menu, value, index, type, isProperty = false ) => {
    
      
    if (menu == "") return;
    const controlDataOptions = value.options
    return (
      <li style={{borderBottom: "1px solid #cccccc"}}
        key={"li" + index}
        name={index}
        onMouseEnter={() => setCurrentSetting({ currentEvent:currentSetting.currentEvent ,  menu:menu, type:type, isProperty:isProperty, 
          maskData: value.maskData ? value.maskData : ""  ,
          parents:{id: [currentToolIds[0], ...firstCurrentTool.parentId], globalId: [currentToolGlobalIds[0], ...firstCurrentTool.parentGlobalId]},
          errors:[],
          option :getOption(menu, type, controlDataOptions),
          text : {value: value.relationShipValue ? value.relationShipValue : value.value, isClick:false},
          control : {id: currentToolIds[0], globalId:currentToolGlobalIds[0]},
          data : menu == "data"? value.value: undefined,
          controlDataOptions : controlDataOptions,
          api : getApi(menu, type),
          conditions:getCondition(menu, type)})}>
        <div style={{display: "flex"}}>
          <div
            id={index}
            className="shortMenuLabel cutText"
            onMouseEnter={() => setIsShowToolTip(true)}
            onMouseLeave={() => setIsShowToolTip(false)}
          >
            {menu}
          </div>
          {!isProperty ?
            <React.Fragment>
              <input
                type="text"
                name="text"
                className="shortMenuTextBox"
                value={value.value}
                onChange={(e) => changeValue(e.target.value, menu, type, isProperty)}
                onMouseLeave={() => changeMode(false)}
                onMouseDown={() => changeMode(true)} />  
              <div className="shortMenuIcon">
                {currentSetting.menu === menu && (
                  <EditIcon
                    height={props.height}
                    width={props.width}
                    onClick={() => onToggle()}
                  />            
                )} 
              </div>
            </React.Fragment>
          : getPropertyOptions(menu, value, type, isProperty)
        }
        </div>
        <ToolTip
          canShowToolTip={menu === currentSetting.menu && isShowToolTip}
          text={menu}
        />
      </li>
    );
  };

  const getPropertyOptions = (menu, propertyItem, type, isProperty )=> {
    switch (propertyItem.control) {
      case "ListBox":
        return (
          <React.Fragment>
            <div className="sepProperty" />   
              <DropDownListNew
                fontSize={12}
                id={"Filter" + propertyItem.value}
                currentData={propertyItem.values}
                initialValue={propertyItem.value}
                onDropDownItemClick={(itemSelected) =>
                  changeValue(itemSelected.value, menu, type, isProperty) }
                onlyLabel={false}
              />
           
          </React.Fragment>)
      case "ListBoxCheckBox":
        
        return (
          <React.Fragment>
            <div className="sepProperty" />   
              <DropDownListNew
                fontSize={12}
                id={"Filter" + propertyItem.value}
                currentData={propertyItem.values}
                multiSelection={true}
                selectedValues={propertyItem.selectedValues.map(item => item.id)}
                initialValue={propertyItem.value}
                onDropDownItemClick={(itemSelected) =>
                  changeValue(itemSelected.value, menu, type, isProperty) }
                onlyLabel={false}
              />
           
          </React.Fragment>)
      case "CheckBox":
        return (
          <React.Fragment>
            <div className="shortMenuTextBox" >   
              <CheckBox checked={propertyItem.value} click ={() => 
                changeValue(!propertyItem.value, menu, type, isProperty)}  />
            </div>
          </React.Fragment>)
      default:
        return ( 
          <React.Fragment>
            <input
              type="text"
              name="text"
              className="shortMenuTextBox"
              value={propertyItem.value}
              onChange={(e) => changeValue(e.target.value, menu, type, isProperty)}
              onMouseLeave={() => changeMode(false)}
              onMouseDown={() => changeMode(true)}
              onKeyPress = {(e) => fireEventKeyPressByTool(e, type, menu, globalState.state.formData.actions.event.type.onkeyPress) }
              onBlur = {(e) => fireOtherEventByTool(e, type, menu, globalState.state.formData.actions.event.type.onBlur, false) }
            />  
            <div className="shortMenuIcon">
              {currentSetting.menu === menu && (
                <EditIcon
                  height={props.height}
                  width={props.width}
                  onClick={() => onToggle()}/>    
                          
              )} 

            </div>
          </React.Fragment>)
        
    }
  };

  const getStyles = (joinStyles) => {
    if (firstCurrentTool)
      joinStyles = Object.entries(firstCurrentTool.styles)
        .map(([toolName, toolValue]) => { return { ["menu"]: toolName, ["value"]: toolValue } }).flat(1);

    globalState.state.formData.currentTool.slice(1).map(
      tool => {
        let joinStylesNames = joinStyles.map(property => property.menu);
        joinStyles = Object.entries(tool.styles)
          .filter(([name, value]) => joinStylesNames.includes(name)
          ).map(([toolName, toolValue]) => { return { ["menu"]: toolName, ["value"]: toolValue } }).flat(1)
      }
    )

    return joinStyles
  };
 
  const getEvents = (type, menu) => { 
    return globalState.state.formData.lists.validations[type.toLowerCase()][menu]
 }
 
  const fireEventKeyPressByTool = (e, type, menu, event) => {
    var typeEvents = getEvents(type, menu)
    if (typeEvents) {
      typeEvents = typeEvents[event]
      if(!isInputValid({value: e.key}, typeEvents).isValid) {
        e.preventDefault()
      }
    }
  }

  const fireOtherEventByTool = (e, type, menu,event, changeModeValue = undefined) => {
    
    var typeEvents = getEvents(type, menu)
    if (typeEvents) {
      
      typeEvents = typeEvents[event]
      const allColumnsWithoutCurrent = allColumns.filter(item=> item.id != globalState.state.formData.currentTool[0].id)
      const input = isInputValid({value: e.target.value, values:allColumnsWithoutCurrent.map(name => name.item.toLowerCase())
      }, typeEvents)
      if(!input.isValid) {
        e.preventDefault()
        if(menu == "name") {
          const nextId = parseInt(globalState.state.formData.lists.currentMaxId) + 1 
          changeValue(e.target.value + "0" + nextId , menu, type, true, undefined , false)
          changeModeValue=undefined
        }
      }
    }
    if(changeModeValue != undefined ) {
      
      changeMode(changeModeValue)
    }
  }
  
  const onDropDownItemClick = (itemSelected, event = currentSetting.currentEvent) => {
    var updatedToolData = JSON.parse(JSON.stringify(globalState.state.formData));

    var currentsTools = [];
    getCurrentsTools(updatedToolData, currentsTools, [itemSelected.id], {event:event, type:"byId"});
    updatedToolData.currentTool = currentsTools;
    
    dispatch({
      type: "UPDATE_FORM_WITOUT_HISTORIQUE",
      payload: updatedToolData,
    });
  };

  const onSelectEvent = (itemSelected) => {
    
    setCurrentSetting({...currentSetting, currentEvent:itemSelected.item})
    
    onDropDownItemClick({id:firstCurrentTool.id, item:firstCurrentTool.properties.name}, itemSelected.item)
  };

  const getCurrentText = () => {
    return firstCurrentTool && firstCurrentTool.properties.name ? firstCurrentTool.properties.name.value : "";
  }

  const getProcessData = () => {
    return globalState.state.step.decisions.map(item => {return {id:item.id, item:item.item
      , childs:item.childs.map(child=> {return {id:child.id, item:child.item, childs:[] }})}} ) 
  }

  return (
    
    <div>
      <div style={{display: "flex"}}>
        <div  style={{minWidth: "115px", maxWidth: "115px" }}>
          <DropDownListNew
            currentData={allColumns}
            initialValue={getCurrentText()}
            id={"ToolLists"}
            onDropDownItemClick={(itemSelected) => onDropDownItemClick(itemSelected)}
            onlyLabel={false}/>
        </div>
        <div  style={{minWidth: "115px", maxWidth: "115px" }}>
          <DropDownListNew
            currentData={globalState.state.formData.actions.event.lists}
            initialValue={currentSetting.currentEvent}
            id={"EventLists"}
            onDropDownItemClick={(itemSelected) => onSelectEvent(itemSelected)}
            onlyLabel={false}/>
        </div>
      </div>
    <div style={{display: "flex"}}>
      {tool.isToolOpen ? (
        <div className="toolsContainer">
          <div className="toolsTitle">{tools.name}</div>
          {props.tools.map((tool) => (
            <ul className="ulMenu" key={"ul" + tool.id}>
              <div
                className="menuGroup"
                onClick={() => onExpandCollapseClick(tool.id)}
              >
                <div
                  style={{
                    marginTop: reduceds.includes(tool.id) ? -2 : 0,
                    marginRight: reduceds.includes(tool.id) ? 4 : 1,
                    marginLeft: 10,
                  }}
                >
                  {reduceds.includes(tool.id) ? " -   " : "+"}
                </div>

                <div
                  style={{
                    marginLeft: 10,
                  }}
                >
                  {tool.type}
                </div>
              </div>
              {!reduceds.includes(tool.id) &&
                tool.items.map((menu) => showMenu(menu))}
            </ul>
          ))}
        </div>
      ) : (
          <div className="toolsContainer">
            <div className="toolsTitle">{settings.name}</div>
            { <ul className="ulMenu" key={property.name}>
              <div
                className="menuGroup"
                onClick={() => onExpandCollapseClick(property.id)}
              >
                <div
                  style={{
                    marginTop: reduceds.includes(property.id) ? -2 : 0,
                    marginRight: reduceds.includes(property.id) ? 4 : 1,
                    marginLeft: 10,
                  }}
                >
                  {reduceds.includes(property.id) ? " -   " : "+"}
                </div>

                <div
                  style={{
                    marginLeft: 10,
                  }}
                >
                  {property.name}
                </div>
              </div>
              {!reduceds.includes(property.id) && globalState.state.formData.currentTool.length == 1 &&
                Object.entries(
                  firstCurrentTool.properties
                ).map(([menu, value], index) =>
                  !value.hide 
                  && (globalState.state.formData.actions.event.type.onLoad == currentSetting.currentEvent || menu == "actions")
                  && showSettings(menu, value, index, property.name, true)
                )}
            </ul>}
            <ul className="ulMenu" key={style.name}>
              <div
                className="menuGroup"
                onClick={() => onExpandCollapseClick(style.id)}
              >
                <div
                  style={{
                    marginTop: reduceds.includes(style.id) ? -2 : 0,
                    marginRight: reduceds.includes(style.id) ? 4 : 1,
                    marginLeft: 10,
                  }}
                >
                  {reduceds.includes(style.id) ? " -   " : "+"}
                </div>

                <div
                  style={{
                    marginLeft: 10,
                  }}
                >
                  {style.name}
                </div>
              </div>
              {!reduceds.includes(style.id) &&
                //getStyles([])
                
                Object.entries(
                  firstCurrentTool.styles
                ).map(([menu, value], index) => !value.hide && showSettings(menu, value, index, style.name)
                )}
            </ul>
          </div>
        )}

      <div>
        {menuItems.map(item =>
          <div key={item.id} className="rotation-wrapper-outer">
            <div className="rotation-wrapper-inner">
              <p
                className="element-to-rotate"
                onMouseEnter={() => onMouseMenu(item.id)}>
                {item.name}
              </p>
            </div>
          </div>
        )
        }
      </div>
      
      
      { isShowing && 
      <SimpleModal 
        columnsNames = {allColumns.filter(item=> item.id != globalState.state.formData.currentTool[0].id).map(name => name.item.toLowerCase())} 
        formData = {globalState.state.formData} isShowing={isShowing} settings={currentSetting}
        previousForms = {globalState.state.previousForms}
        process = {globalState.state.step ? getProcessData() : []}
        //onValidChange={(item) => changeValue(item.text.value, item.menu, item.type, item.isProperty, item.conditions, false)} 
        onValidChange={(item) => changeValue(item.text.value, item.menu, item.type, item.isProperty, item, false)} 
        hide={() => {toggle() ; changeMode(false)}} />}
      </div>
    </div>
  );
}
